// DS: CR51
// https://zpl.io/aRzpEyK
import React, { useContext } from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../DeviationViews/Dumbo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './DeviationsMosaic.scss';
const defaultPadding = parseInt(s['padding']);
const thumbSpacing = parseInt(s['thumb-spacing']);
const mobileThumbSpacing = parseInt(s['mobile-thumb-spacing']);
export const DeviationsMosaic = ({ width , height , className , contentClassName , deviations , padding , deviationView: DeviationView = DeviationDumbView  })=>{
    const isMobile = useContext(MobileContext);
    if (!deviations.length) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width,
                height
            },
            className: className
        });
    }
    if (deviations.length === 1) {
        return /*#__PURE__*/ React.createElement(DeviationView, {
            deviation: deviations[0],
            width: width,
            height: height
        });
    }
    const effectivePadding = padding !== undefined ? padding : defaultPadding;
    const effectiveThumbSpacing = isMobile ? mobileThumbSpacing : thumbSpacing;
    const fullWidth = width - effectivePadding * 2;
    const fullHeight = height - effectivePadding * 2;
    const halfWidth = Math.floor((fullWidth - effectiveThumbSpacing) / 2);
    const halfHeight = Math.floor((fullHeight - effectiveThumbSpacing) / 2);
    let rightHalf;
    if (deviations.length > 2) {
        rightHalf = /*#__PURE__*/ React.createElement("div", {
            className: s['vertical-tile']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['horizontal-tile']
        }, /*#__PURE__*/ React.createElement(DeviationView, {
            deviation: deviations[1],
            width: halfWidth,
            height: halfHeight
        })), /*#__PURE__*/ React.createElement("div", {
            className: s['horizontal-tile']
        }, /*#__PURE__*/ React.createElement(DeviationView, {
            deviation: deviations[2],
            width: halfWidth,
            height: halfHeight
        })));
    } else {
        rightHalf = /*#__PURE__*/ React.createElement("div", {
            className: s['vertical-tile']
        }, /*#__PURE__*/ React.createElement(DeviationView, {
            deviation: deviations[1],
            width: halfWidth,
            height: fullHeight
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], className),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['tiles'], contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['vertical-tile']
    }, /*#__PURE__*/ React.createElement(DeviationView, {
        deviation: deviations[0],
        width: halfWidth,
        height: fullHeight
    })), rightHalf));
};
export default DeviationsMosaic;
